// Lib
import { createSelector, createStructuredSelector } from 'reselect';

// Utils
import {
    getUserReactionsRecentlyUsed,
    getUserReactionsSkinTone,
} from '../../../../common/users/utils/userPropertyUtils';

// Selectors
import { getCurrentUser } from '../../../user/currentUserSelector';
import { getCmsData } from '../../../cms/cmsSelector';

// Constants
import { RECENTLY_USED_DEFAULTS } from './emojiPopupConstants';
import { Emoji, RecentlyUsedEmojis } from '../emojiTypes';
import { CmsEntities } from '../../../cms/cmsConstants';

const getCmsEmojiData = createSelector(getCmsData(CmsEntities.EMOJI), (emoji): Emoji[] => emoji || []);

const emojiPopupSelector = createStructuredSelector({
    emojiData: getCmsEmojiData,
    recentlyUsed: (state): RecentlyUsedEmojis => {
        const recent = getUserReactionsRecentlyUsed(getCurrentUser(state));

        return recent ? recent.toJS() : RECENTLY_USED_DEFAULTS;
    },
    skinTone: (state) => getUserReactionsSkinTone(getCurrentUser(state)),
});

export default emojiPopupSelector;
